export default "__VITE_ASSET__BwOuMoaZ__"